/**
 * Copyright ©2026 Drivepoint
 */

import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DPButton from "@components/DPButton/DPButton";
import Telemetry from "@services/telemetry/Telemetry";
import "./TryNewUIButton.css";

const NEW_UI_PATH = "/neo/";

export default function TryNewUIButton() {

  function handleTryNewUI() {
    Telemetry.track("TryNewUIButton Try New UI", {path: NEW_UI_PATH});
    window.location.assign(NEW_UI_PATH);
  }

  return <div className="try-new-ui-button">
    <DPButton
      size="small"
      variant="outlined"
      color="primary"
      startIcon={<OpenInNewIcon />}
      label="Try New UI"
      onClick={handleTryNewUI}
    />
  </div>;
}
